import { render, staticRenderFns } from "./ProvincialStatistics.vue?vue&type=template&id=4ddb835a&"
import script from "./ProvincialStatistics.vue?vue&type=script&lang=js&"
export * from "./ProvincialStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ProvincialStatistics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProvincialStatistics.vue"
export default component.exports